export enum StaffSettingsRouteName {
    Index = 'staff.settings.index',
    Profile = 'staff.settings.profile',
    Security = 'staff.settings.security',
    Notifications = 'staff.settings.notifications',
}

export default {
    path: '/settings',
    name: StaffSettingsRouteName.Index,
    component: () => import('@/views/settings/Index.vue'),
    meta: {
        label: 'Settings',
        auth: true,
    },
    children: [
        {
            path: 'profile',
            name: StaffSettingsRouteName.Profile,
            component: () => import('@/views/settings/profile/Index.vue'),
            meta: {
                label: 'Profile Settings',
                auth: true,
            },
        },
        {
            path: 'security',
            name: StaffSettingsRouteName.Security,
            component: () => import('@/views/settings/security/Index.vue'),
            meta: {
                label: 'Security Settings',
                auth: true,
            },
        },
        {
            path: 'notifications',
            name: StaffSettingsRouteName.Notifications,
            component: () => import('@/views/settings/notification/Index.vue'),
            meta: {
                label: 'Notification Settings',
                auth: true,
            },
        },
    ],
}
